import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "view-tab" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ozn_button = _resolveComponent("ozn-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.viewArray, (view, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "view-tab__container",
        key: `view-${index}-${view.id}`
      }, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createVNode(_component_ozn_button, {
            class: _normalizeClass(["view-tab__button", { 'view-tab__button--active': _ctx.activeViewId === view.id }]),
            onClick: ($event: any) => (_ctx.handleClick(view.id))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(view.name), 1)
            ]),
            _: 2
          }, 1032, ["onClick", "class"])
        ], true)
      ]))
    }), 128))
  ]))
}